import ContactForm from 'components/ContactForm';
import React from 'react';
import { Helmet } from 'react-helmet';

const ContactUs = () => {
  return (
    <div>
      <Helmet>
        <title>Book a Service</title>
      </Helmet>
      <ContactForm />
    </div>
  );
};

export default ContactUs;
